import React, { Component, Fragment } from 'react';
import SignetRow from './SignetRow';
import { Row, Col, Card, Table } from 'react-bootstrap';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import withTranslations from '../../utils/HighOrderComponent';

class SignetTable extends Component {
  render() {
    const { t, isUserProcessor, isUserAuthorizedPerson } = this.props || {},
      { HeaderColumns, titleTable } = t || {};
    const signetList = this.props.signetList.map((signet, index) => (
      <SignetRow
        index={index + 1}
        key={signet.id}
        signet={signet}
        isUserProcessor={isUserProcessor}
        isUserAuthorizedPerson={isUserAuthorizedPerson}
      />
    ));

    const table = (
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <Row>
                <Col className="col-md-8">
                  <Card.Title as="h3">{titleTable}</Card.Title>
                </Col>
              </Row>
            </Card.Header>
            <Table responsive hover id="table">
              <thead>
                <tr className=" text-center">
                  <th className="align-top" width="4%">
                    #
                  </th>
                  <th className="align-top" width="10%">
                    {HeaderColumns.request}
                  </th>
                  <th className="align-top" width="14%">
                    {HeaderColumns.uniqueNumber}
                  </th>
                  <th className="align-top">
                    {HeaderColumns.organizationalUnit}
                  </th>
                  <th className="align-top" width="14%">
                    {HeaderColumns.plannedStart}
                  </th>
                  <th className="align-top" width="14%">
                    {HeaderColumns.statusChangedDate}
                  </th>
                  <th className="align-top">
                    {HeaderColumns.authorizedPerson}
                  </th>
                  <th className="align-top">{HeaderColumns.signetState}</th>
                  <th className="align-top">{HeaderColumns.signetStatus}</th>
                  <th className="align-top">{HeaderColumns.processing}</th>
                </tr>
              </thead>
              <tbody>{signetList}</tbody>
            </Table>
          </Card>
        </Col>
      </Row>
    );

    return <Fragment>{table}</Fragment>;
  }
}

export default withTranslations(SignetTable, 'SignetTable');
